import React, { type CSSProperties } from 'react';

type Props = {
    size?: string | number;
    style?: CSSProperties;
};

export function IconComponent({ size = 24, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            style={{ verticalAlign: 'middle', ...style }}
            aria-hidden="true"
        >
            <path
                d="M2.8076 12.7071C2.41708 12.3166 2.41708 11.6834 2.8076 11.2929L5.63603 8.46446C6.02655 8.07393 6.65972 8.07393 7.05024 8.46446L9.87867 11.2929C10.2692 11.6834 10.2692 12.3166 9.87867 12.7071L7.05024 15.5355C6.65972 15.926 6.02655 15.926 5.63603 15.5355L2.8076 12.7071Z"
                fill="currentColor"
            />
            <path
                d="M8.46446 7.05024C8.07393 6.65972 8.07393 6.02655 8.46446 5.63603L11.2929 2.8076C11.6834 2.41708 12.3166 2.41708 12.7071 2.8076L15.5355 5.63603C15.926 6.02655 15.926 6.65972 15.5355 7.05024L12.7071 9.87867C12.3166 10.2692 11.6834 10.2692 11.2929 9.87867L8.46446 7.05024Z"
                fill="currentColor"
            />
            <path
                d="M8.46446 18.364C8.07393 17.9734 8.07393 17.3403 8.46446 16.9497L11.2929 14.1213C11.6834 13.7308 12.3166 13.7308 12.7071 14.1213L15.5355 16.9497C15.926 17.3403 15.926 17.9734 15.5355 18.364L12.7071 21.1924C12.3166 21.5829 11.6834 21.5829 11.2929 21.1924L8.46446 18.364Z"
                fill="currentColor"
            />
            <path
                d="M14.1213 12.7071C13.7308 12.3166 13.7308 11.6834 14.1213 11.2929L16.9497 8.46446C17.3403 8.07393 17.9734 8.07393 18.364 8.46446L21.1924 11.2929C21.5829 11.6834 21.5829 12.3166 21.1924 12.7071L18.364 15.5355C17.9734 15.926 17.3403 15.926 16.9497 15.5355L14.1213 12.7071Z"
                fill="currentColor"
            />
        </svg>
    );
}
